/**
 * Created by Анжелика on 25.08.2017.
 */
import React, {Component, Fragment} from "react";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import PropTypes from "prop-types";
import * as GenresActions from "../actions/genres";
import * as ChannelActions from '../actions/channels';
import * as UserDataActions from '../actions/userData';
import * as ChannelCardsActions from '../actions/channelCards';
import AppRoutes from "../components/AppRoutes";
import PortalContainer from '../components/PortalContainer';
import PopupPersonalAccount from '../components/PopupPersonalAccount'
import {getCookie, setCookie} from '../utils'
import {IS_SHOW_POPUP} from '../constants/cookies'

class Player extends Component {

    constructor(props) {
        super(props);
        this.state = {
            uploaded: false,
            isShowPopup: false
        }
    }

    componentDidMount() {
        const {genresActions, channelsActions, userDataActions, channelCardsActions} = this.props;

        userDataActions.getUserData().then(({hasError}) => {
            if (!hasError) {
                userDataActions.startSendUserActivity();
                genresActions.getGenres().then(({hasError}) => {
                    if (!hasError) {
                        channelsActions.getChannels().then(({hasError}) => {
                            if (!hasError) {
                                userDataActions.loadUserConfig();
                                channelCardsActions.loadChannelCardsUserConfig();
                                this.setState({uploaded: true});
                            }
                        })
                    }
                })
            }
        })
    }

    componentWillUnmount() {
        const {userDataActions} = this.props;
        userDataActions.stopSendUserActivity();
    }

    componentDidUpdate() {
        const { userData } = this.props;
        const { isShowPopup } = this.state;
        if (userData && (!userData.briz_tv.email || !userData.briz_tv.phone)) {
          if (!isShowPopup && !getCookie(IS_SHOW_POPUP)) {
            this.setState({ isShowPopup: true });
            setCookie(IS_SHOW_POPUP,"shown", 86400)
          }
        }
      }

      closePopup = () => {
        this.setState({ isShowPopup: false });
      }

    render() {
        const {isShowPopup} = this.state
        return (
            !this.state.uploaded ?
                <div className="preload">
                    <div className="fetching">
                        <div className="spinner"></div>
                    </div>
                </div>
                : 
                <Fragment>
                    <AppRoutes />
                    {isShowPopup ? <PortalContainer>
                        <PopupPersonalAccount handleClose = { this.closePopup }  />
                    </PortalContainer> : null}
                </Fragment>
        )
    }
}

Player.propTypes = {
    users: PropTypes.object.isRequired,
    channelsActions: PropTypes.object.isRequired,
    genresActions: PropTypes.object.isRequired,
    userDataActions: PropTypes.object.isRequired,
    channelCardsActions: PropTypes.object.isRequired,
};


const mapStateToProps = state => {
    return {
        users: state.users,
        userData: state.users.userData.data
    }
};

const mapDispatchToProps = dispatch => {
    return {
        genresActions: bindActionCreators(GenresActions, dispatch),
        channelsActions: bindActionCreators(ChannelActions, dispatch),
        userDataActions: bindActionCreators(UserDataActions, dispatch),
        channelCardsActions: bindActionCreators(ChannelCardsActions, dispatch),
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Player);




// WEBPACK FOOTER //
// ./src/containers/Player.js